import { Building2, CalendarDays, ClipboardList, FileText, Gauge, MessageSquare, ShieldCheck, Tags } from "lucide-react";
import { ConsoleShell } from "@/pages/portal/PortalLayout";
import { useAuth } from "@/context/AuthContext";

const INS_ROLES = ["owner", "workshop_manager", "service_advisor"];

export default function AdminLayout() {
  const { user, isAdmin } = useAuth();
  const insStaff = (user?.roles || []).some((r) => INS_ROLES.includes(r));
  const nav = [
    ["overview", "Overview", Gauge, "/admin"], ["board", "Workshop Board", ClipboardList, "/admin/board"],
    ["quotes", "Quotes & Invoices", FileText, "/admin/quotes"], ["bookings", "Bookings", CalendarDays, "/admin/bookings"],
    ...(insStaff ? [["insurance", "Insurance Requests", ShieldCheck, "/admin/insurance"]] : []),
    ["services", "Price Editor", Tags, "/admin/services"], ["messages", "Messages", MessageSquare, "/admin/messages"],
    ...(insStaff ? [["insurers", isAdmin ? "Settings: Insurers" : "Insurers", Building2, "/admin/insurers"]] : []),
  ];
  return <ConsoleShell nav={nav} title="Workshop" testPrefix="admin" />;
}
